import { z } from 'zod';

/** Summary row for `GET /lasso/v1/threads` (first turn per session). */
export const LassoThreadSummaryDtoSchema = z.object({
  sessionId: z.string(),
  prompt: z.string(),
  responsePreview: z.string(),
  updatedAt: z.string(),
});

export type LassoThreadSummaryDto = z.infer<
  typeof LassoThreadSummaryDtoSchema
>;

/** One persisted prompt/response pair in a Lasso session. */
export const LassoSessionTurnDtoSchema = z.object({
  id: z.number(),
  prompt: z.string(),
  response: z.string(),
  feedback: z.union([z.literal(1), z.literal(-1), z.null()]),
  feedbackLabel: z.array(z.string()).nullable(),
  feedbackMessage: z.string().nullable(),
  createdAt: z.string(),
});

export type LassoSessionTurnDto = z.infer<typeof LassoSessionTurnDtoSchema>;

/** Full session transcript for `GET /lasso/v1/threads/:sessionId`. */
export const LassoSessionDetailDtoSchema = z.object({
  sessionId: z.string(),
  turns: z.array(LassoSessionTurnDtoSchema),
});

export type LassoSessionDetailDto = z.infer<
  typeof LassoSessionDetailDtoSchema
>;

/** Body for `PATCH /lasso/v1/turns/:id/feedback`. */
export const LassoFeedbackPatchDtoSchema = z.object({
  feedback: z.union([z.literal(1), z.literal(-1), z.null()]).optional(),
  feedbackLabel: z.array(z.string()).optional(),
  feedbackMessage: z.string().nullable().optional(),
});

export type LassoFeedbackPatchDto = z.infer<
  typeof LassoFeedbackPatchDtoSchema
>;
